<template>
    <div class="container" style="max-width: 85%;">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <card-component titulo="Lista dos Lançamentos" componente="bb" :usuario="userJson">
                    <template v-slot:conteudo>
                        <div class="row">
                            <div class="col-1 mb-3">
                                <input-container-component titulo="ID" id="inputid">
                                    <input type="text" class="form-control" id="inputid" placeholder="Informe o id"
                                        v-model="busca.id" @keyup="pesquisar()">
                                </input-container-component>
                            </div>
                            <div class="col-2 mb-3">
                                <input-container-component titulo="Descricao" id="inputDescricao">
                                    <input type="text" class="form-control" id="inputDescricao"
                                        placeholder="Informe a Descricao" v-model="busca.descricao"
                                        @keyup="pesquisar()">
                                </input-container-component>
                            </div>
                            <div class="col-2 mb-3">
                                <input-container-component titulo="Fornecedor" id="inputFornecedor">
                                    <input type="text" class="form-control" id="inputFornecedor"
                                        placeholder="Informe o Fornecedor" v-model="busca.fornecedor"
                                        @keyup="pesquisar()">
                                </input-container-component>
                            </div>
                            <div class="col-3 mb-3">
                                <input-container-component titulo="Filtrar Status">
                                    <select name="filtroStatus" class="form-control" id="filtroStatus"
                                        v-model="busca.status" @change="pesquisar()">
                                        <option selected></option>
                                        <option v-if="userJson.nivel_acesso != 'adm'" value="criacao" selected>Criação
                                        </option>
                                        <option v-if="userJson.nivel_acesso == 'adm'" value="pendente">Pend. Pagamento
                                        </option>
                                        <option value="pago">Pend. Comprovante</option>
                                        <option value="finalizado">Proc. Finalizado</option>
                                        <option v-if="userJson.nivel_acesso == 'adm'" value="taxa">Taxa Transação
                                        </option>
                                    </select>
                                </input-container-component>
                            </div>
                            <div class="col-3 mb-3" v-if="userJson.nivel_acesso == 'adm'">
                                <input-container-component titulo="Caps">
                                    <select name="caps_lan" class="form-control" id="caps_lan" @change="filtroCaps">
                                        <option selected></option>
                                        <option value="1">Sede</option>
                                        <option value="2">Novo Tempo</option>
                                        <option value="5">David Capstrano</option>
                                        <option value="6">Estação</option>
                                        <option value="7">Integração</option>
                                        <option value="9">Toninho</option>
                                        <option value="10">Esperanca</option>
                                    </select>
                                </input-container-component>
                            </div>
                            <div class="mb-4">
                                <button type="button" class="btn btn-primary btn-sm float-end" data-bs-toggle="modal"
                                    data-bs-target="#modalLanDescricao">
                                    Adicionar
                                </button>
                            </div>
                            <div class="mb-4">
                                <button type="button" class="btn btn-success btn-sm float-end" data-bs-toggle="modal"
                                    data-bs-target="#modalExportarXLS">
                                    Exportar XLS
                                </button>
                            </div>
                        </div>
                        <table-component :dados="lancamentos.data" componentpai="landesc" :status="true" :pdf="{
                            url: 'bb'
                        }" :editar="{
                            visivel: true,
                            dataToggle: 'modal',
                            dataTarget: '#modalLancamentoAtualizar'
                        }" :removerbb="{
                            visivel: true,
                            dataToggle: 'modal',
                            dataTarget: '#modalLancamentoRemover'
                        }" :titulos="{
                            id: { titulo: 'ID', tipo: 'texto' },
                            aprovacao: { titulo: 'Aprovação', tipo: '' },
                            status: { titulo: 'Status', tipo: 'status' },
                            descricao: { titulo: 'Descrição', tipo: 'texto' },
                            valor_comprovante: { titulo: 'Valor Comprovante', tipo: 'texto' },
                            fornecedor: { titulo: 'Fornecedor', tipo: 'texto' },
                            caps: { titulo: 'Caps Lancamento', tipo: '' },
                            created_at: { titulo: 'Data Criação', tipo: 'data' },
                            nome_paciente: { titulo: 'Rateio', tipo: 'texto' },
                        }"></table-component>
                    </template>
                    <template v-slot:rodape>
                        <div class="row">
                            <div class="col-12">
                                <paginate-component>
                                    <li v-for="l, key in lancamentos.links" :key="key"
                                        :class="l.active ? 'page-item active' : 'page-item'"><a class="page-link"
                                            v-html="l.label" @click="paginacao(l)"></a></li>
                                </paginate-component>
                            </div>
                        </div>
                    </template>
                </card-component>
            </div>
        </div>

        <modal-component id="modalLanDescricao" titulo="Adicionar Lancamento">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="transacaoDetalhes" titulo="Cadastro realizado com sucesso!"
                    v-if="transacaoStatus == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="transacaoDetalhes" titulo="Erro ao cadastrar."
                    v-if="transacaoStatus == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo>
                <div class="form-group">
                    <input-container-component titulo="Descrição" id="novoLancamento">
                        <select name="descricao" class="form-control" id="novoLancamento" v-model="lanDescricao">
                            <option v-for="lista in listaDescricao" :key="lista.id" :value="lista.descricao">
                                {{ lista.descricao }}
                            </option>
                        </select>
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Valor Comprovante" id="novoValorComprovante">
                        <input type="text" class="form-control" id="novoValorComprovante"
                            placeholder="Informe o Valor Comprovante" v-model="lanValorComprovante"
                            @input="aplicarMascaraLanDesc($event, 'adicionar')">
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Fornecedor" id="novoFornecedor">
                        <input type="text" class="form-control" id="novoFornecedor" placeholder="Informe o Fornecedor"
                            v-model="lanFornecedor" @input="fetchResultsForn('adicionar')">
                    </input-container-component>
                    <ul v-if="searchResultsForn.length > 0" class="list-group">
                        <li v-for="item in searchResultsForn" :key="item.id"
                            class="list-group-item list-group-item-action" @click="setFornecedor(item, 'adicionar')">
                            {{ item.razao_social }}
                        </li>
                    </ul>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Tipo Pagamento">
                        <select name="novoTipoPagamento" class="form-control" id="novoTipoPagamento"
                            v-model="tipoPagamento">
                            <option selected></option>
                            <option>PIX</option>
                            <option>BOLETO</option>
                        </select>
                    </input-container-component>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Codigo Pagamento" id="novoCodigoPagamento">
                        <input type="text" class="form-control" id="novoCodigoPagamento"
                            placeholder="Informe Codigo Pagamento" v-model="codigoPagamento">
                    </input-container-component>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-primary" @click="salvarLanDescricao()">Salvar</button>
            </template>
        </modal-component>

        <modal-component id="modalLancamentoAtualizar" titulo="Atualizar Lançamento" tipomodal="modal-xl">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="$store.state.transacao.mensagem"
                    titulo="Lançamento atualizado com sucesso!"
                    v-if="$store.state.transacao.status == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="$store.state.transacao.mensagem" titulo="Erro ao atualizar."
                    v-if="$store.state.transacao.status == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo>
                <div class="row" style="justify-content: center;">
                    <div class="col-6">
                        <button type="button" class="btn btn-primary btn-sm mb-3 float-end" @click="aprovacao()"
                            v-if="userJson.nivel_acesso == 'gestor' && $store.state.item.status == 'finalizado' && $store.state.item.aprovacao != 'sim'">
                            Aprovação Gestor
                        </button>
                        <button type="button" class="btn btn-primary btn-sm mb-3 float-end" @click="duplicarLan()"
                            v-if="userJson.nivel_acesso == 'adm' && $store.state.item.status != 'taxa' && $store.state.item.status != 'pendente'">
                            Duplicar Lançamento
                        </button>
                        <div class="row">
                            <div class="col"
                                v-if="($store.state.item.status == 'pago' && userJson.nivel_acesso != 'adm') || ($store.state.item.status == 'taxa' && userJson.nivel_acesso == 'adm')">
                                <label class="custom-file-upload float-start">
                                    <input type="file" style="display: none" @change="carregarImagem($event)"
                                        id="inputImagem" name="imagem" />
                                    <a class="btn btn-outline-primary btn-sm d-inline"> Nota Fiscal </a>
                                </label>
                                <p v-if="nomeArquivo" class="text-success mt-2 mb-2 float-start">
                                    Arquivo carregado: {{ nomeArquivo }}
                                </p>
                            </div>
                            <div class="col" v-if="verificaImagemStatus">
                                <button type="button" class="btn btn-primary btn-sm float-end"
                                    @click="statusLancamento()">
                                    Finalizar Lançamento
                                </button>
                            </div>
                        </div>
                        <div class="row mt-2 mb-3" v-if="$store.state.item.imagem">
                            <a :href="'/storage/' + $store.state.item.imagem" target="_blank">Nota Fiscal</a>
                        </div>
                        <div class="row mt-2 mb-3">
                            <b>ID: {{ $store.state.item.id }}</b>
                        </div>
                        <div>
                            <div class="form-group"
                                v-if="$store.state.item.descricao && !$store.state.item.descricao.includes('(TAXA-TRANSACAO)')">
                                <input-container-component titulo="Descrição" id="atualizarLancamento">
                                    <select name="descricao" class="form-control" id="atualizarLancamento"
                                        v-model="$store.state.item.descricao"
                                        :disabled="$store.state.item.status != 'criacao' || userJson.nivel_acesso == 'adm'">
                                        <option v-for="lista in listaDescricao" :key="lista.id"
                                            :value="lista.descricao">
                                            {{ lista.descricao }}
                                        </option>
                                    </select>
                                </input-container-component>
                            </div>
                            <p v-else><b>Descrição:</b> {{ $store.state.item.descricao }}</p>
                        </div>
                        <div>
                            <div class="form-group mt-3">
                                <input-container-component titulo="Valor Comprovante" id="atualizarValorComprovante">
                                    <input type="text" class="form-control" id="atualizarValorComprovante"
                                        placeholder="Informe o Valor Comprovante"
                                        v-model="$store.state.item.valor_comprovante"
                                        @input="aplicarMascaraLanDesc($event, 'atualizar')"
                                        :disabled="$store.state.item.status != 'criacao' || userJson.nivel_acesso == 'adm'">
                                </input-container-component>
                            </div>
                            <div class="form-group mt-3">
                                <input-container-component titulo="Fornecedor" id="atualizarFornecedor">
                                    <input type="text" class="form-control" id="atualizarFornecedor"
                                        placeholder="Informe o Fornecedor" v-model="$store.state.item.fornecedor"
                                        @input="fetchResultsForn('atualizar')"
                                        :disabled="$store.state.item.status != 'criacao' || userJson.nivel_acesso == 'adm'">
                                </input-container-component>
                                <ul v-if="searchResultsForn.length > 0" class="list-group">
                                    <li v-for="item in searchResultsForn" :key="item.id"
                                        class="list-group-item list-group-item-action"
                                        @click="setFornecedor(item, 'atualizar')">
                                        {{ item.razao_social }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div>
                            <div class="form-group mt-3">
                                <input-container-component titulo="Tipo Pagamento">
                                    <select name="novoTipoPagamento" class="form-control" id="novoTipoPagamento"
                                        v-model="$store.state.item.tipo_pagamento"
                                        :disabled="$store.state.item.status != 'criacao' || userJson.nivel_acesso == 'adm'">
                                        <option selected></option>
                                        <option>PIX</option>
                                        <option>BOLETO</option>
                                    </select>
                                </input-container-component>
                            </div>
                        </div>
                        <div class="form-group mt-3">
                            <input-container-component titulo="Codigo Pagamento" id="novoCodigoPagamento">
                                <input type="text" class="form-control" id="novoCodigoPagamento"
                                    placeholder="Informe Codigo Pagamento" v-model="$store.state.item.codigo_pagamento"
                                    :disabled="$store.state.item.status != 'criacao' || userJson.nivel_acesso == 'adm'">
                            </input-container-component>
                        </div>
                        <div class="form-group mt-3" v-if="userJson.nivel_acesso == 'adm'">
                            <input-container-component titulo="Status Pagamento" id="atualizarFornecedor">
                                <select name="atualizarStatus" id="atualizarStatus" class="form-control"
                                    v-model="$store.state.item.status">
                                    <option value="pago">Pago</option>
                                    <option value="pendente">Pendente</option>
                                    <option v-if="userJson.nivel_acesso == 'adm'" value="taxa">Taxa</option>
                                    <option v-if="userJson.nivel_acesso == 'adm'" value="finalizado">Finalizado
                                    </option>
                                    <option v-if="userJson.nivel_acesso == 'adm'" value="criacao">Criação
                                    </option>
                                </select>
                            </input-container-component>
                        </div>
                        <div class="row mt-2" v-if="$store.state.item.status != 'finalizado' && userJson.nivel_acesso == 'adm'">
                            <label class="custom-file-upload float-start">
                                <input type="file" style="display: none" @change="carregarImagemPago($event)"
                                    id="inputImagemPago" name="imagemPago" />
                                <a class="btn btn-outline-primary btn-sm d-inline"> Comprovante Pagamento </a><br>
                            </label>
                            <p v-if="nomeArquivoPago" class="text-success mt-2 mb-2 float-start">
                                Arquivo carregado: {{ nomeArquivoPago }}
                            </p>
                        </div>
                        <div class="row mt-3" v-if="$store.state.item.comprovante_pagamento">
                            <a :href="'/storage/' + $store.state.item.comprovante_pagamento" target="_blank">Comprovante
                                Pagamento</a>
                        </div>
                    </div>
                </div>
                <hr>
                <lan-rateio-component v-if="exibirRateio" ref="lanRateio" :nivelacesso="userJson.nivel_acesso"
                    :rateiosalvar="salvarRateio"></lan-rateio-component>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-primary" @click="atualizarLanDescricao()"
                    v-if="$store.state.item.status == 'criacao' || userJson.nivel_acesso == 'adm'">Atualizar</button>
            </template>
        </modal-component>
        <!-- #######################################################################################################################
####################################################################################################################### -->
        <modal-component id="modalLancamentoRemover" titulo="Remover Lançamento">
            <template v-slot:alertas>
                <alert-component tipo="success" :detalhes="$store.state.transacao.mensagem"
                    titulo="Lançamento atualizado com sucesso!"
                    v-if="$store.state.transacao.status == 'sucesso'"></alert-component>
                <alert-component tipo="danger" :detalhes="$store.state.transacao.mensagem" titulo="Erro ao atualizar."
                    v-if="$store.state.transacao.status == 'erro'"></alert-component>
            </template>
            <template v-slot:conteudo>
                <div class="row mt-2 mb-3">
                    <b>ID: {{ $store.state.item.id }}</b>
                </div>
                <div>
                    <div class="form-group">
                        <input-container-component titulo="Descrição" id="removerLancamento">
                            <input type="text" class="form-control" id="removerLancamento"
                                placeholder="Informe Descrição" v-model="$store.state.item.descricao" disabled>
                        </input-container-component>
                    </div>
                </div>
                <div>
                    <div class="form-group mt-3">
                        <input-container-component titulo="Valor Comprovante" id="removerValorComprovante">
                            <input type="text" class="form-control" id="removerValorComprovante"
                                placeholder="Informe o Valor Comprovante" v-model="$store.state.item.valor_comprovante"
                                disabled>
                        </input-container-component>
                    </div>
                    <div class="form-group mt-3">
                        <input-container-component titulo="Fornecedor" id="removerFornecedor">
                            <input type="text" class="form-control" id="removerFornecedor"
                                placeholder="Informe o Fornecedor" v-model="$store.state.item.fornecedor" disabled>
                        </input-container-component>
                    </div>
                </div>
                <div>
                    <div class="form-group mt-3">
                        <input-container-component titulo="Tipo Pagamento">
                            <select name="removerTipoPagamento" class="form-control" id="removerTipoPagamento"
                                v-model="$store.state.item.tipo_pagamento" disabled>
                                <option selected></option>
                                <option>PIX</option>
                                <option>BOLETO</option>
                            </select>
                        </input-container-component>
                    </div>
                </div>
                <div class="form-group mt-3">
                    <input-container-component titulo="Codigo Pagamento" id="removerCodigoPagamento">
                        <input type="text" class="form-control" id="removerCodigoPagamento"
                            placeholder="Informe Codigo Pagamento" v-model="$store.state.item.codigo_pagamento"
                            disabled>
                    </input-container-component>
                </div>
                <div class="form-group mt-3" v-if="userJson.nivel_acesso == 'adm'">
                    <input-container-component titulo="Status Pagamento" id="removerFornecedor">
                        <select name="removerStatus" id="removerStatus" class="form-control"
                            v-model="$store.state.item.status" disabled>
                            <option value="pago">Pago</option>
                            <option value="pendente">Pendente</option>
                            <option value="taxa">Taxa</option>
                            <option value="finalizado">Finalizado</option>
                        </select>
                    </input-container-component>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                <button type="button" class="btn btn-primary" @click="removerLan($store.state.item.id)"
                    :disabled="$store.state.transacao.status == 'sucesso'"
                    v-if="$store.state.item.status == 'criacao' || userJson.nivel_acesso == 'adm'">Remover</button>
            </template>
        </modal-component>
        <!-- #######################################################################################################################
####################################################################################################################### -->
        <modal-component id="modalRateio" titulo="Rateio Lançamento" tipomodal="modal-xl"
            @modal-aberto="$refs.lanRateio.carregarRateiosExistentes()" insert>
            <template v-slot:conteudo>
                <lan-rateio-component ref="lanRateio" :nivelacesso="userJson.nivel_acesso"></lan-rateio-component>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
            </template>
        </modal-component>
        <!-- #######################################################################################################################
####################################################################################################################### -->
        <modal-component id="modalExportarXLS" titulo="Exportar XLS" tipomodal="modal-xl">
            <template v-slot:conteudo>
                <div class="row">
                    <div class="col">
                        <input-container-component titulo="Data Inicio" id="data_txt_inicio">
                            <input type="date" class="form-control" id="data_txt_inicio" v-model="dtXlsInicio">
                        </input-container-component>
                    </div>
                    <div class="col">
                        <input-container-component titulo="Data Fim" id="data_txt_fim">
                            <input type="date" class="form-control" id="data_txt_fim" v-model="dtXlsFim">
                        </input-container-component>
                    </div>
                    <div class="col">
                        <input-container-component titulo="">
                            <a :href="'https://contasmoradores.candido.org.br/exportar/bb/' +
                                dtXlsInicio + '/' + dtXlsFim" class="btn btn-secondary float-end" 
                                style="font-size: 11px;">Exportar XLS</a>
                        </input-container-component>
                    </div>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
            </template>
        </modal-component>
        <div v-if="load_update" class="overlay">
            <div class="spinner">Processando...</div>
        </div>
    </div>
</template>

<script>

export default {
    props: ['user', 'centrocusto'],
    data() {
        return {
            urlBase: 'https://contasmoradores.candido.org.br/api/v1/lancamento',
            urlPaginacao: '',
            urlFiltro: '',
            lancamentos: { data: [] },
            lanDescricao: '',
            lanValorComprovante: '',
            lanFornecedor: '',
            nomePaciente: '',
            codContaCaixa: '',
            centroCusto: '',
            tipoPagamento: '',
            codigoPagamento: '',
            fornecedorId: '',
            imagem: [],
            imagemPago: [],
            nomeArquivoPago: '',
            listaDescricao: {},
            urlPreview: "",
            urlPreviewPago: "",
            comparaFornecedor: [],
            searchResultsForn: [],
            transacaoStatus: '',
            transacaoDetalhes: {},
            busca: { descricao: '', status: '', caps_id: '', fornecedor: '', id: '' },
            links: {},
            nomeArquivo: "",
            filtroUser: '&filtro=status:=:criacao',
            load_update: false,
            exibirRateio: true,
            salvarRateio: 0,
            dtXlsInicio: '',
            dtXlsFim: ''
        }
    },
    methods: {
        resetTransacao() {
            this.transacaoStatus = ''
            this.transacaoDetalhes = ''
            this.lanDescricao = ''
            this.lanValorComprovante = ''
            this.lanFornecedor = ''
            this.tipoPagamento = ''
            this.codigoPagamento = ''
            this.nomeArquivo = ""
            this.exibirRateio = false;
        },
        filtroStatus(e) {
            this.busca.status = e.target.value
            this.pesquisar()
        },
        filtroCaps(e) {
            this.busca.caps_id = e.target.value
            this.pesquisar()
        },
        carregarImagem(e) {
            console.log(e.target.files[0])
            this.imagem = e.target.files;
            this.urlPreview = URL.createObjectURL(this.imagem[0]);
            this.nomeArquivo = this.imagem[0].name
            this.atualizarLanDescricao()
        },
        carregarImagemPago(e) {
            this.imagemPago = e.target.files;
            this.urlPreviewPago = URL.createObjectURL(this.imagemPago[0]);
            this.nomeArquivoPago = this.imagemPago[0].name
        },
        fetchResultsForn(val) {
            let search;
            if (val === 'adicionar') {
                if (this.lanFornecedor.length < 2) {
                    this.searchResultsForn = [];
                    return;
                }
                search = this.lanFornecedor.toLowerCase();
            } else {
                if (this.$store.state.item.fornecedor.length < 2) {
                    this.searchResultsForn = [];
                    return;
                }
                search = this.$store.state.item.fornecedor.toLowerCase();
            }

            // Busca no estado do Vuex
            const allSuppliers = this.$store.state.fornecedor || [];

            // Filtra os resultados
            this.searchResultsForn = allSuppliers.filter(fornecedor =>
                fornecedor.razao_social.toLowerCase().includes(search)
            );
        },
        async setFornecedorStore() {
            try {
                const response = await axios.get(`/busca-fornecedor-store?caps_id=${this.userJson.caps_id}`);
                this.$store.state.fornecedor = response.data;
            } catch (error) {
                console.error("Erro ao buscar registros:", error);
            }
        },
        setFornecedor(item, val) {
            if (val == 'adicionar') {
                this.lanFornecedor = item.razao_social
                this.fornecedorId = item.id
            } else {
                this.$store.state.item.fornecedor = item.razao_social
                this.$store.state.item.forn_id = item.id
            }
            this.searchResultsForn = [];
        },
        async fetchResultsStore() {
            try {
                const response = await axios.get(`/busca-pacientes-store?caps_id=${this.userJson.caps_id}`);
                this.$store.state.pacientes = response.data;
            } catch (error) {
                console.error("Erro ao buscar registros:", error);
            }
        },
        aprovacao() {
            alert('Confirmar aprovação?')
            this.load_update = true

            let formData = new FormData()
            formData.append('id', this.$store.state.item.id)
            formData.append('caps_id', this.userJson.caps_id)
            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/aprovacao', formData, config)
                .then(response => {
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                })
                .catch(errors => {
                    console.log(errors.response)
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.message,
                        dados: errors.response.data.errors
                    }
                    this.load_update = false
                })
                .finally(() => {
                    this.load_update = false
                })
        },
        duplicarLan() {
            let valorcomp = prompt('Insira o valor do lançamento a ser duplicado')
            if (!valorcomp) {
                return
            }
            let formData = new FormData()
            formData.append('id', this.$store.state.item.id)
            formData.append('descricao', this.$store.state.item.descricao)
            formData.append('valor_comprovante', valorcomp)

            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/duplicate', formData, config)
                .then(response => {
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                })
                .catch(errors => {
                    console.log(errors.response)
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.message,
                        dados: errors.response.data.errors
                    }
                })
        },
        atualizarCreatedAt(id, data) {
            let formData = new FormData()
            formData.append('lan_desc_id', id)
            formData.append('nova_data', data)

            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/update-data-lan', formData, config)
                .then(response => {
                })
                .catch(errors => {
                    console.log(errors.response)
                })
        },
        async atualizarLanDescricao() {
            let formData = new FormData()
            formData.append('_method', 'patch')
            formData.append('centro_custo', this.$store.state.item.caps.centro_custo)
            formData.append('descricao', this.$store.state.item.descricao)
            formData.append('valor_comprovante', this.$store.state.item.valor_comprovante)
            formData.append('fornecedor', this.$store.state.item.fornecedor)
            formData.append('tipo_pagamento', this.$store.state.item.tipo_pagamento)
            formData.append('codigo_pagamento', this.$store.state.item.codigo_pagamento)
            formData.append('status', this.$store.state.item.status)
            formData.append('caps_id', this.$store.state.item.caps_id)
            formData.append('forn_id', this.$store.state.item.forn_id)
            if (this.userJson.nivel_acesso == 'adm' && (this.$store.state.item.status == 'pago' || this.$store.state.item.status == 'taxa')) {
                if (this.imagemPago[0]) {
                    formData.append("comprovante_pagamento", this.imagemPago[0]);
                    formData.append('status_importacao', 'pendente')
                }
            }
            if (this.imagem[0]) {
                formData.append("imagem", this.imagem[0]);
            }

            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/lan_descricao' + '/' + this.$store.state.item.id, formData, config)
                .then(response => {
                    if (this.exibirRateio) {
                        this.salvarRateio++
                    }
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                    this.resetTransacao()
                    this.exibirRateio = true
                })
                .catch(errors => {
                    console.log(errors.response)
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.message,
                        dados: errors.response.data.errors
                    }
                })
        },
        async comparaRateio() {
            let rateios = []
            try {
                const response = await axios.get(`https://contasmoradores.candido.org.br/api/v1/lancamento?filtro=lan_desc_id:=:${this.$store.state.item.id}`);
                rateios = response.data
            } catch (error) {
                console.error("Erro ao carregar rateios existentes:", error);
            }
            // Calcula a soma dos valores de rateio, convertendo para número corretamente
            const soma = rateios.reduce((total, item) => {
                // Converte a string formatada para número, se necessário
                const valor = this.converterParaNumero(item.valor_paciente) || 0;
                return total + valor;
            }, 0); // Valor inicial do acumulador é 0

            let number = typeof this.$store.state.item.valor_comprovante === 'string' ? parseFloat(this.$store.state.item.valor_comprovante.replace(/\./g, '').replace(',', '.')) : this.$store.state.item.valor_comprovante;

            // Formata para moeda brasileira (R$ 1.000,00)
            number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            if (number.toFixed(2) != soma.toFixed(2)) {
                alert('A soma do retio precisa ser igual ao valor do comprovante! Valor Comprovante: ' + number.toFixed(2) + ', Soma Rateio: ' + soma.toFixed(2))
                return false
            }
            return true
        },
        async statusLancamento() {
            if (!this.comparaRateio()) {
                return
            }

            if (this.$store.state.item.status === 'finalizado' && (!this.$store.state.item.imagem || !this.$store.state.item.comprovante_pagamento)) {
                alert('É obrigatório anexar a Nota Fiscal e o comprovante de pagamento.');
                return false;
            }

            await this.atualizarLanDescricao()
            let confirmacao = confirm('Após confirmar não será mais possvível editar!')

            if (!confirmacao) return false

            if (this.userJson.nivel_acesso == 'adm') {
                this.comparaRateio()
            }

            let formData = new FormData()
            formData.append('_method', 'patch')
            formData.append('status', 'finalizado')
            formData.append('status_importacao', 'pendente')
            formData.append('caps_id', this.$store.state.item.caps_id)

            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            await axios.post('https://contasmoradores.candido.org.br/api/v1/lan_descricao' + '/' + this.$store.state.item.id, formData, config)
                .then(response => {
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                })
                .catch(errors => {
                    console.log(errors.response.data)
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        },
        pesquisar() {
            let filtro = ''
            for (let chave in this.busca) {
                if (this.busca[chave]) {
                    if (filtro != '') {
                        filtro += ';'
                    }
                    if (chave == 'caps_id') {
                        filtro += chave + ':like:' + this.busca[chave]
                    } else {
                        filtro += chave + ':like:' + this.busca[chave] + '%' 
                    }
                }
            }

            if (filtro != '') {
                this.urlPaginacao = 'page=1'
                if (this.userJson.nivel_acesso != 'adm') {
                    this.urlFiltro = ';' + filtro + '%' 
                } else {
                    this.urlFiltro = '&filtro=' + filtro + '%' 
                }
            } else {
                this.urlFiltro = ''
            }
            console.log(this.urlFiltro)
            this.carregarLista()
        },
        paginacao(l) {
            if (l.url) {
                this.urlPaginacao = l.url.split('?')[1]
                this.carregarLista()
            }
        },
        async carregarLista() {
            let url = ''
            if (this.userJson.nivel_acesso != 'adm') {
                url = 'https://contasmoradores.candido.org.br/api/v1/lan_descricao' + '?' + this.urlPaginacao + '&filtro=caps_id:=:' + this.userJson.caps_id + this.urlFiltro
                // '&filtro=caps_id:=:' + this.userJson.caps_id 
            } else {
                url = 'https://contasmoradores.candido.org.br/api/v1/lan_descricao' + '?' + this.urlPaginacao + '&filtroin=status:pendente:pago:finalizado:taxa' + this.urlFiltro
            }

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }
            axios.get(url, config)
                .then(response => {
                    this.lancamentos = response.data

                    if (this.$store.state.item.id) {
                        const updateItem = this.lancamentos.data.find(dado => dado.id === this.$store.state.item.id)
                        this.$store.commit('SET_ITEM', updateItem)
                    }
                })
                .catch(errors => {
                })
        },
        salvarLanDescricao() {
            let formData = new FormData()
            formData.append('centro_custo', this.centrocusto)
            formData.append('descricao', this.lanDescricao)
            formData.append('valor_comprovante', this.lanValorComprovante)
            formData.append('fornecedor', this.lanFornecedor)
            formData.append('tipo_pagamento', this.tipoPagamento)
            formData.append('codigo_pagamento', this.codigoPagamento)
            formData.append('status', 'criacao')
            formData.append('operacao', 'saque manual')
            formData.append('filial', '1')
            formData.append('conta_caixa', '003')
            formData.append('historico', 'GASTOS DOS MORADORES')
            formData.append('compensado', 'true')
            formData.append('conta_credito', '141')
            formData.append('caps_id', this.userJson.caps_id)
            formData.append('forn_id', this.fornecedorId)

            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/lan_descricao', formData, config)
                .then(response => {
                    this.carregarLista()
                    this.transacaoStatus = 'sucesso'
                    this.transacaoDetalhes = {
                        mensagem: ''
                    }
                    setTimeout(() => {
                        const btn = document.getElementById(`lan_rateio${response.data.id}`)
                        if (btn) btn.click()
                    }, 1000)
                })
                .catch(errors => {
                    console.log(errors.response.data)
                    this.transacaoStatus = 'erro'
                    this.transacaoDetalhes = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        },
        aplicarMascaraLanDesc(event, val) {
            let valor = event.target.value;

            // Remove todos os caracteres que não são números
            valor = valor.replace(/\D/g, '');

            // Se estiver vazio, evita erro e mantém a string vazia
            if (valor === '') {
                if (val === 'adicionar') this.lanValorComprovante = '';
                if (val === 'atualizar') this.$store.state.item.valor_comprovante = '';
                return;
            }

            // Converte para número e divide por 100 para formatar como decimal
            valor = (parseInt(valor, 10) / 100).toFixed(2);

            // Formata o valor no padrão brasileiro (vírgula decimal, pontos para milhar)
            valor = valor.replace('.', ',');
            valor = valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

            // Atualiza o valor no item do array
            if (val === 'adicionar') this.lanValorComprovante = valor;
            if (val === 'atualizar') this.$store.state.item.valor_comprovante = valor;

            // Atualiza a interface do input
            this.$nextTick(() => {
                event.target.value = valor;
            });
        },
        testeUpdateStatus() {
            let processos = ['182', '183', '184', '185'];
            let formData = new FormData()
            processos.forEach((p) => {
                formData.append('processos[]', p)
            })

            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/status_importacao', formData, config)
                .then(response => {
                    console.log(response.data.mensagem)
                })
                .catch(errors => {
                    console.log(errors.response.data)
                })
        },
        removerLan(id) {
            let confirmacao = confirm('Confirmar remoção do registro!')

            if (!confirmacao) return false

            let formData = new FormData()
            formData.append('id', id)

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/removelan-bb', formData, config)
                .then(response => {
                    this.carregarLista()
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                })
                .catch(errors => {
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        },
        carregarListaDescricao() {
            let url = 'https://contasmoradores.candido.org.br/api/v1/descpadrao?apenas_nomes=id,descricao'

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.get(url, config)
                .then(response => {
                    this.listaDescricao = response.data
                })
                .catch(error => {
                    console.error("Erro na requisição:", error);
                });
        },
    },
    mounted() {
        this.carregarLista()
        this.setFornecedorStore()
        this.fetchResultsStore()
        this.carregarListaDescricao()
        // Obtém o elemento da modal pelo ID
        const modalElement = document.getElementById('modalLanDescricao');
        const modalElementAtualizar = document.getElementById('modalLancamentoAtualizar');

        // Adiciona o evento de fechamento da modal para resetar as variáveis
        modalElement.addEventListener('hidden.bs.modal', () => {
            setTimeout(() => {
                this.exibirRateio = true
            }, 1000)
        });
        modalElementAtualizar.addEventListener('hidden.bs.modal', async () => {
            this.resetTransacao()
            await this.carregarLista()
        });
        modalElementAtualizar.addEventListener('show.bs.modal', () => {
            this.exibirRateio = true;
        });
    },
    beforeUnmount() {
        // Remove o evento ao desmontar o componente para evitar vazamento de memória
        const modalElement = document.getElementById('modalLanDescricao');
        const modalElementAtualizar = document.getElementById('modalLancamentoAtualizar');
        modalElement.removeEventListener('hidden.bs.modal', this.resetTransacao);
        modalElementAtualizar.addEventListener('hidden.bs.modal', this.resetTransacao);
    },
    computed: {
        token() {
            let token = 'Bearer ' + document.cookie.split(';').find(indice => {
                return indice.includes('token=')
            }).split('=')[1]
            return token
        },

        userJson() {
            return JSON.parse(this.user);
        },
        formattedValue: {
            get() {
                return this.lanValorComprovante;
            },
            set(value) {
                // Converte para um formato adequado sem perder os centavos
                this.lanValorComprovante = value.replace(/[^0-9,]/g, '').replace(/^0+/, '') || "0,00";
            }
        },
        verificaImagemStatus() {
            if (this.userJson.nivel_acesso != 'adm' && this.$store.state.item.status == 'pago' && this.$store.state.item.imagem) {
                return true
            } if (this.userJson.nivel_acesso == 'adm' && this.$store.state.item.status == 'taxa' && this.$store.state.item.imagem) {
                return true
            } else {
                return false
            }
        },
        imagemDisponivel() {
            return this.$store.state.item.imagem != null;
        }
    },
}
</script>
<style scoped>
.list-group-item {
    cursor: pointer;
}

.text-success {
    color: green;
    font-weight: bold;
}


.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(270deg, #ff6b6b, #feca57, #48dbfb, #1dd1a1);
    background-size: 800% 800%;
    animation: gradientAnimation 10s ease infinite;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    opacity: 0.6;
}

.spinner {
    color: #000;
    font-size: 1.5rem;
    font-weight: bold;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

@keyframes gradientAnimation {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}
</style>